import { 
  HOME_ACTION, 
  COMMON_CONTENT_ACTION, 
  HOME_ACTION_LOADER,
  COMMON_CONTENT_ACTION_LOADER
} from "../type"
 
const initialState ={
    loader : false,
    common_loader: false, // 👈 add this
    common_loaded: false,
    data :{},
    common_data :{}
}
 
const HomeReducer  = (state = initialState, action) => {
    switch (action.type){

        case HOME_ACTION_LOADER:
            return {...state, loader : action.loader};

        case COMMON_CONTENT_ACTION_LOADER:  // 👈 add this
            return {...state, common_loader : action.loader};

        case HOME_ACTION:
            return {...state, data: action.data};

        case COMMON_CONTENT_ACTION:
            return {...state, common_data: action.data, common_loaded: true};

        default:
            return state
    }
}
 
export default HomeReducer;
